import Button from '../Button';
import RichText from '../RichText/RichText';

import type { RichTextButtonProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/RichTextButtonProps';

const RichTextButton = (props: RichTextButtonProps) => (
  <RichText
    {...props.richTextProps}
    // TODO: QUAR-1784 - remove enableExperimentTracking prop once homepage_hero_redirect_offsite experiment is done
    appendComponent={<Button {...props.buttonProps} enableExperimentTracking />}
  />
);

export default RichTextButton;
